import React from "react";
import NextLink from "next/link";
import { DynamicArticleItem, TagItem } from "@/components/PageHome/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import RelatedArticles from "@/components/ArticlePage/Components/RelatedArticles";
import { FILTER_MAPPING } from "@/helpers/constants";
import { getResourceListingURL } from "@/helpers";
import styles from "./ArticleAyurveda.module.scss";

interface ArticleAyurvedaProps {
  Title: string;
  Tag?: TagItem;
  articles?: DynamicArticleItem[];
  userAgent: DeviceInfo;
  category?: string;
  assetPosition?: number;
  isPharma?: boolean;
}

const ArticleAyurveda: React.FC<ArticleAyurvedaProps> = ({
  articles,
  Tag,
  Title,
  userAgent,
  category,
  assetPosition,
  isPharma,
}: ArticleAyurvedaProps) => {
  const tags = [Tag];

  const getLink: () => string = () => {
    return getResourceListingURL(
      { [FILTER_MAPPING.category]: [category], [FILTER_MAPPING.tag]: ["ayurveda"] },
      "articles"
    );
  };

  return (
    <section className={`${styles.root} spacingBetweenSections`}>
      <div className={"container"}>
        <RelatedArticles
          items={articles}
          title={Title}
          userAgent={userAgent}
          tags={tags}
          titleClass={styles.title}
          desktopItems={3}
          assetPosition={assetPosition}
          isPharma={isPharma}
        />
        {!!articles?.length && (
          <div className={styles.viewMore}>
            <NextLink href={getLink()} className={styles.link} prefetch={false}>
              View more articles
            </NextLink>
          </div>
        )}
      </div>
    </section>
  );
};

export default ArticleAyurveda;
